module.exports = __webpack_public_path__ + "img/202410_08.9b7c959b.jpg";